import script from "./CreatePopupEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePopupEvent.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePopupEvent.vue?vue&type=style&index=0&id=30a80198&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a80198"]])

export default __exports__